export const trainedModels = {
  speech_model: [
    {
      id: 5,
      domain_id: 1,
      path: 'some/path',
      status: 'FAILED_TO_TRAIN',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
    {
      id: 4,
      domain_id: 1,
      path: 'some/path',
      status: 'FAILED_TO_TRAIN',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
    {
      id: 3,
      domain_id: 1,
      path: 'some/path',
      status: 'TRAINED',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
    {
      id: 2,
      domain_id: 1,
      path: 'some/path',
      status: 'ACTIVE',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
    {
      id: 1,
      domain_id: 1,
      path: 'some/path',
      status: 'TRAINED',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
  ],
};

export const trainStatusActive = {
  speech_model: [
    {
      id: 5,
      domain_id: 1,
      path: 'some/path',
      status: 'CREATED',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
    {
      id: 3,
      domain_id: 1,
      path: 'some/path',
      status: 'TRAINED',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
    {
      id: 2,
      domain_id: 1,
      path: 'some/path',
      status: 'ACTIVE',
      timestamp: '2022-09-07T07:19:32.367935+00:00',
    },
  ],
};
